import { ReactNode } from "react";
import { cn } from "../utls/utils";

interface FullScreenContainerProps {
  children: ReactNode;
  className?: string;
  backgroundClassName?: string;
}

/**
 * Utility wrapper that lets a section break out of the AppLayout's fixed width
 * container and span the entire viewport width while keeping the content centered.
 */
export default function FullScreenContainer({
  children,
  className,
  backgroundClassName,
}: FullScreenContainerProps) {
  return (
    <div className={cn("w-full", backgroundClassName)}>
      <div
        className={cn(
          "mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
